"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeEventHandlers = composeEventHandlers;

/**
 * Based off Zendesk Utilities Library
 * Original License - Apache-2.0
 * https://github.com/zendeskgarden/react-containers/blob/main/packages/utilities/src/utils/composeEventHandlers.ts
 *
 * We are using the .some() array method to iterate through all
 * the provided functions and stop if defaultPrevented is true.
*/
function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      fn && fn.apply(void 0, [event].concat(args));
      return event && event.defaultPrevented;
    });
  };
}